import { IListarComprovantesUsuarioRequest, IListarComprovantesUsuarioResponse } from "../../../Interfaces/Vendas/Usuario/UsuarioInterface";
import {
    DashboardCorretorVendasService,
    ListarCompromissosUsuarioService,
    ListarPerfilUsuarioVendasService,
    ListarUsuariosPorEquipeVendasService,
    ListarUsuariosVendasService,
} from "../../../Services/Vendas/Usuario/UsuarioService";
import { Controller } from "../../Controller";

export async function ListarUsuariosVendasController() {
    return Controller(ListarUsuariosVendasService());
}

export async function ListarUsuariosPorEquipeVendasController(
    ID_EQUIPE_VENDAS: number
) {
    return Controller(ListarUsuariosPorEquipeVendasService(ID_EQUIPE_VENDAS));
}

export async function ListarPerfilUsuarioVendasController() {
    return Controller(ListarPerfilUsuarioVendasService());
}

export async function ListarCompromissosUsuarioController(
    requestBody: IListarComprovantesUsuarioRequest
) {
    return Controller(
        ListarCompromissosUsuarioService<Array<IListarComprovantesUsuarioResponse>>(false, requestBody)
    );
}
export async function ExportarCompromissosUsuarioExcelController(
    requestBody: IListarComprovantesUsuarioRequest
) {
    return Controller(
        ListarCompromissosUsuarioService<Blob>(true, requestBody)
    );
}


export async function DashboardCorretorVendasController(
    ID_TIPO_ATIVIDADE: number,
    ID_EMPREENDIMENTO: number,
    DT_INICIO: string,
    DT_FIM: string
) {
    return Controller(
        DashboardCorretorVendasService(
            ID_TIPO_ATIVIDADE,
            ID_EMPREENDIMENTO,
            DT_INICIO,
            DT_FIM
        )
    );
}
